import { IconType } from "react-icons";
import { ComponentType, SVGProps } from "react";

export const FaIcon = (icon: IconType) =>
  icon as unknown as ComponentType<SVGProps<SVGSVGElement> & { size?: string | number; color?: string }>;